export default __webpack_public_path__ + "static/media/pitch.94ac9068.jpg";